import type { RadioOptionType } from '@openx/components-core/lib/RadioField/types';
import type { ConstValues } from '@openx/types/helpers';

export type PredefinedSegmentType = ConstValues<typeof PredefinedSegmentType>;
export const PredefinedSegmentType = {
  PartnerAudiences: 'partner_audiences',
  ThirdPartyData: 'third_party_data',
  PastBrowsingInterests: 'past_browsing_interests',
  OxPurchaseData: 'ox_purchase_data',
} as const;

export type LocationSegmentType = ConstValues<typeof LocationSegmentType>;
export const LocationSegmentType = {
  State: 'state',
  Zip: 'zip',
  DMA: 'dma',
  Congressional: 'congressional',
} as const;

export type Propensity = ConstValues<typeof Propensity>;
export const Propensity = {
  ALL: '*',
  LOW: 'L',
  MEDIUM: 'M',
  HIGH: 'H',
} as const;

export const audienceLocation = {
  Any: 'any',
  State: 'state',
  DMA: 'dma',
  ZipCode: 'zip',
  CongressionalDistrict: 'congressional',
} as const;

export type SelectedLocationSegment = ConstValues<typeof audienceLocation>;

export const audienceLocationOptions: RadioOptionType[] = [
  {
    'data-test': 'audience-criteria-location-any',
    label: 'Any',
    value: audienceLocation.Any,
  },
  {
    'data-test': 'audience-criteria-location-state',
    label: 'State',
    value: audienceLocation.State,
  },
  {
    'data-test': 'audience-criteria-location-dma',
    label: 'DMA',
    value: audienceLocation.DMA,
  },
  {
    'data-test': 'audience-criteria-location-zipcode',
    label: 'Zip Code',
    value: audienceLocation.ZipCode,
  },
  {
    'data-test': 'audience-criteria-location-congressional-district',
    label: 'Congressional District',
    value: audienceLocation.CongressionalDistrict,
  },
];
